import { Button } from "primereact/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../css/Dashboard.css';
import { useEffect, useState } from "react";
import ManageArticles from "../components/ManageArticles";
import ManageWatermark from "../components/ManageWatermark";
import ManageAccount from "../components/ManageAccount";
import ManagePlans from "../components/ManagePlans";
import ManageOrders from "../components/ManageOrders";
import { apiClient } from "../apiClient";
import { useOnlineStatus } from "../context/OnlineContext";
import colors from '../colors';
import DashboardTutorial from "../components/Tutorial/DashboardTutorial";


function DashboardPage(props)
{

  const user= JSON.parse(localStorage.getItem('seo_app')); 
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
  const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
  const location = useLocation();
  const currentPath = location.pathname; 
  const [userHasArticle,setUserHasArticle] = useState(true);
  const [userHasWatermark,setUserHasWatermark] = useState(true);
  const [userHasPlan,setUserHasPlan] = useState(true);
  const [userHasInfo,setUserHasInfo] = useState(true);
  const { online, setOnline , dashboardTutorialSeen , setDashboardTutorialSeen} = useOnlineStatus();
  


  //check if user has ordered any article:
  useEffect( () =>
    {

      if(user)
        apiClient.get(process.env.REACT_APP_BACK+"/articles/hasArticle/"+user?._id, config)
        .then((response) => {
          if (response.status == 200)
            setUserHasArticle(response.data)
        })
        .catch((error) => {
          console.log("axios error");
     
        });
    },[]);


  //check if user has watermark:
  useEffect( ()=> { 

      if(user)  
        apiClient.get(process.env.REACT_APP_BACK+"/users/hasWatermark/"+user?._id, config)
        .then((response) => {
          if (response.status == 200)
            setUserHasWatermark(response.data)
        })
        .catch((error) => {
          console.log("axios error");
         
        });
  
      },[]);


  //check if user has plan:
  useEffect( () =>
  {
    if(user)
      apiClient.get(process.env.REACT_APP_BACK+"/users/hasPlan/"+user?._id, config)
    .then((response) => {
      if (response.status == 200)
        setUserHasPlan(response.data)
    })
    .catch((error) => {
      console.log("axios error");

    });
  }
    
    ,[]);




  //check if user has info:
  useEffect( () =>
    {
      if(user)
        apiClient.get(process.env.REACT_APP_BACK+"/users/hasInfo/"+user?._id, config)
        .then((response) => {
          if (response.status == 200)
            setUserHasInfo(response.data)
        })
        .catch((error) => {
          console.log("axios error");
          
        });

    },[]);




  //logout user:
  const logout = () => 
  {
  
    if(user)
      apiClient.get(process.env.REACT_APP_BACK+"/users/logout", config)
    .then((response) => {
      if (response.status == 200)
      {
         // Set online status to false
         setOnline(false);
        
         navigate("/");
      }
      
    })
    .catch((error) => {
      console.log("axios error");
     
    });

    //delete user cache:
    localStorage.removeItem('seo_app');  
    localStorage.removeItem('userToken');
  }


  //set tutorialSeen to true:
  const SaveDashboardTutorialSeen = (seen) =>
  {
    const data = {dashboardTutorialSeen:seen};

    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+user?._id,data,config)
        .then((response) => {
          
          if (response.status == 202)
          {
            setDashboardTutorialSeen(seen);
          }
          
        })
        .catch((error) => {
          console.log("axios error");
     
        });
  }


  


  //check desktop or laptop:
  useEffect(() => {
    window
    .matchMedia("(min-width: 768px)")
    .addEventListener('change', e => setDesktop( e.matches ));
  }, []);

    return(

        <div id="manager">

    {!dashboardTutorialSeen && <DashboardTutorial SaveDashboardTutorialSeen={SaveDashboardTutorialSeen} />}

    {desktop ? 

    <div id="nav-bar-wrap" style={{width:"6%"}}>
      {/* <div id="logo-icon">
      <Link to="/">
          <img src={require("../images/logo.png")} alt={process.env.REACT_APP_ALT} />
      </Link>
      </div> */}

      <div id="nav-icons">

      <div className="nav-bar-item">

      <Link to="/dashboard">
      <Button tooltip="خانه" tooltipOptions={{position:"left"}}
      className={currentPath === "/dashboard" ? "focused-button" : ""}>
        <i className="pi pi-home"></i>
      </Button>
      </Link>
      </div>

      <div className="nav-bar-item">

      <Link to="/dashboard/articles">
      <Button tooltip="مقاله ها" tooltipOptions={{position:"left"}}
      className={currentPath === "/dashboard/articles" ? "focused-button" : ""}>
        <i className="pi pi-book"></i>
      </Button>
      </Link>
      </div>


        <div className="nav-bar-item">

          <Link to="/dashboard/watermark">
          <Button tooltip="واترمارک" tooltipOptions={{position:"left"}}
          className={currentPath === "/dashboard/watermark" ? "focused-button" : ""}>
            <i className="pi pi-images"></i>
          </Button>
          </Link>
        </div>

        <div className="nav-bar-item">
        <Link to="/dashboard/account">
          <Button id="search-button" tooltip="اطلاعات کاربری" tooltipOptions={{position:"left"}}
          className={currentPath === "/dashboard/account" ? "focused-button" : ""}>
            <i className="pi pi-user"></i>
          </Button>
          </Link>
        </div>

        <div className="nav-bar-item">

          <Link to="/dashboard/plans">
          <Button tooltip="پلن های فعال" tooltipOptions={{position:"left"}}
          className={currentPath === "/dashboard/plans" ? "focused-button" : ""}>
            <i className="pi pi-file"></i>
          </Button>
          </Link>
        </div>


       
    



      <div className="nav-bar-item">
          
          
      <Button id="dashboard-logout-button" tooltip="خروج" tooltipOptions={{ position: 'left'}} onClick={logout}>
        <i className="pi pi-power-off"></i>
          </Button>
          
          
          
        </div>

       
      </div>

     
      </div>

      :null}

      <div id="manager-panel">
        
        {props.type === "articles" ? <ManageArticles/>: null}
        {props.type === "watermark" ? <ManageWatermark user_id={user?._id}/>: null}
        {props.type === "account" ? <ManageAccount user_id={user?._id} />: null}
        {props.type === "plans" ? <ManagePlans/>: null}
        {props.type === "dashboard" ? 
        <div style={{paddingBottom: "100px"}}>
          <div >
            
            {user?.name ? 
              <h3>سلام 
                {" "+ user?.name +" "}
                عزیز،
              </h3>
            :
            <h3>سلام 
                {" "+ " تازه وارد "+" "}
                عزیز،
              </h3>

            }
            <h3 style={{marginBottom:"80px"}}>به داشبورد کاربران خوش آمدید</h3>
            </div>



      

      <div id="box-container">
    
            <div className="intro-box">
            {!userHasArticle && <Button tooltip="اولین مقاله تان را سفارش دهید" tooltipOptions={{position:"top"}}>
            <i className="pi pi-cog pi-spin" onClick={() => {navigate("/dashboard/articles")}}></i></Button>}
            <div className="intro-item step1" onClick={()=>{navigate("/dashboard/articles")}}>
                <i className="pi pi-book"></i>
                <h4 className="title">مدیریت مقاله ها</h4>
                <p className="subtitle">مدیریت و ادیت مقاله ها</p>
            </div>
            </div>


            <div className="intro-box">
            {!userHasWatermark && <Button tooltip="واترمارک را انتخاب کنید" tooltipOptions={{position:"top"}}>
              <i className="pi pi-cog pi-spin" onClick={() => {navigate("/dashboard/watermark")}}></i></Button>}
            <div className="intro-item step3" onClick={()=>{navigate("/dashboard/watermark")}}>
                <i className="pi pi-images"></i>
                <h4 className="title"> واترمارک</h4>
                <p className="subtitle">آپلود و ادیت واترمارک</p>
            </div>
            </div>

            <div className="intro-box">
            {!userHasInfo && <Button tooltip="اطلاعات کاربری را تکمیل کنید" tooltipOptions={{position:"top"}}>
            <i className="pi pi-cog pi-spin" onClick={() => {navigate("/dashboard/account")}}></i></Button>}
            <div className="intro-item" onClick={()=>{navigate("/dashboard/account")}}>
                <i className="pi pi-user"></i>
                <h4 className="title">اطلاعات کاربری</h4>
                <p className="subtitle">ویرایش اطلاعات کاربری</p>
            </div>
            </div>

            <div className="intro-box">
            {!userHasPlan && <Button tooltip="پلن خودتان را انتخاب کنید" tooltipOptions={{position:"top"}}>
            <i className="pi pi-cog pi-spin" onClick={() => {navigate("/dashboard/plans")}}></i></Button>}
            <div className="intro-item step2" onClick={()=>{navigate("/dashboard/plans")}}>
                <i className="pi pi-history"></i>
                <h4 className="title">پلن های فعال</h4>
                <p className="subtitle">مشاهده و ویرایش پلن ها</p>
            </div>
            </div>
            

         
            

      </div>
        </div>

        
        
        : null}

      </div>


    {/* mobile nav ********************************************************************************/}
    {!desktop ? 

    <div 
    id="mobile-manager-nav"
    style={{position: "fixed",bottom:"0",direction:"rtl",width:"100%",background:"#ffffff",boxShadow: "rgba(0, 0, 0, 0.81) 0px 1px 4px",zIndex:'2000',paddingLeft:'40px',paddingRight:'40px'}}>

    <span style={{display:"flex"}} id="nav-icons">

    <span style={{display:"flex",direction:"rtl",width: desktop ? "85%" : "100%" , }}>

      <div className="nav-bar-item">
       <div id="logo-icon">
      <Link to="/dashboard">
          <img src={require("../images/logo.png")} alt={process.env.REACT_APP_ALT}/>
      </Link>
      </div>
      </div>

      <div className="nav-bar-item">
      <Link to="/dashboard/articles">
          <Button>
            <i className="pi pi-book"></i>
          </Button>
      </Link>
      </div>

      <div className="nav-bar-item">
      <Link to="/dashboard/watermark">
          <Button id="search-button">
            <i className="pi pi-image"></i>
          </Button>
      </Link>
      </div>


      <div className="nav-bar-item">
      <Link to="/dashboard/account">
          <Button id="search-button">
            <i className="pi pi-user"></i>
          </Button>
      </Link>
      </div>

      

      <div className="nav-bar-item">
      <Link to="/dashboard/plans">
          <Button>
            <i className="pi pi-file"></i>
          </Button>
      </Link>
      </div>

     


      <div className="nav-bar-item">
      
      <Button onClick={logout}>
            <i className="pi pi-sign-out"></i>
          </Button>
      
      </div>

      </span>
      
   

    </span>
    </div>
    : null}

{/********************************************************************************************/}


    </div>

            

    );

}

export default DashboardPage;